import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { environment } from '../../../../environment/environment';

@Component({
  selector: 'app-control-panel',
  imports: [TranslateModule],
  templateUrl: './control-panel.component.html',
  styleUrl: './control-panel.component.css'
})
export class ControlPanelComponent {

  userName: string = localStorage.getItem("userName")!;

  // routeToDashboard() {
  //   const token = localStorage.getItem("token");
  //   const userId = localStorage.getItem("userId");

  //   if (!token || !userId) return;

  //   const url = `https://esrnm-admin-test.jahezteam.com/dashboard?token=${encodeURIComponent(token)}&userId=${encodeURIComponent(userId)}`;

  //   fetch(url, { method: 'HEAD' })
  //     .then(res => {
  //       if (res.ok) {
  //         window.open(url, "_blank");
  //       } else {
  //         console.error("Dashboard URL not found!");
  //         alert("Dashboard is not available right now.");
  //       }
  //     })
  //     .catch(err => console.error(err));

  //   // window.location.href = `https://esrnm-admin-test.jahezteam.com/dashboard?token=${token}&userId=${userId}`;
  //   // window.location.href = `http://localhost:52044/dashboard?token=${token}&userId=${userId}`;

  // }


  routeToDashboards() {
    const token = localStorage.getItem("token");
    if (!token) return;

    // const child = window.open("http://localhost:4200/auth/login", "_blank");
    const child = window.open(environment.DashboardLink + "/auth/login", "_blank");

    if (!child) return;

    const sendInterval = setInterval(() => {
      // child.postMessage({ token }, "http://localhost:4200");
      child.postMessage({ token }, environment.DashboardLink);

    }, 300);

    window.addEventListener("message", function onMessage(event) {
      if (event.data === "received") {
        clearInterval(sendInterval);
        window.removeEventListener("message", onMessage);
      }
    });
  }

}
